import styled from '@emotion/styled';
import { createElement, FC, ReactElement } from 'react';

import ImageScreen from '../primitive/ImageScreen';
import SpFrame from '../primitive/SpFrame';
import VideoScreen from '../primitive/VideoScreen';

type Props = {
  children: ReactElement<typeof VideoScreen | typeof ImageScreen>;
  className?: string;
};

const MediaWithSpFrame: FC<Props> = ({ children, className }) => {
  return (
    <Root className={className}>
      <SpFrame />
      <Media>{children}</Media>
    </Root>
  );
};

const Root = styled('div')({
  position: 'relative',
  width: 200,
});

const Media = styled('div')({
  position: 'absolute',
  top: '0%',
  left: '0%',
  width: '100%',
  height: '100%',
  padding: '14.5% 4.6% 16.4%',
  boxSizing: 'border-box',
});

export default MediaWithSpFrame;
